import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  pagination: {
    margin: theme.spacing(2, 0)
  },
}));

export default styles;
